import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  CircularProgress,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { makeStyles } from "@material-ui/core/styles";
import backgroundImage from "../../assets/img/inicio.jpg";
import { useAuth } from "../../contexts/AuthContext";
import { api } from "../../services/api";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    width: "100vw",
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  loginBox: {
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    padding: theme.spacing(4),
    borderRadius: "15px",
    width: "400px",
    marginRight: theme.spacing(3),
  },
  title: {
    textAlign: "center",
    color: "white",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginBottom: theme.spacing(3),
  },
  inputLabel: {
    color: "white",
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
  textField: {
    marginBottom: theme.spacing(2),
    "& input": {
      borderRadius: "8px",
      backgroundColor: "white",
    },
    backgroundColor: "#4caf50",
    borderRadius: "8px",
  },
  textFieldPass: {
    marginBottom: theme.spacing(2),
    "& input": {
      backgroundColor: "white",
      borderRadius: "8px",
    },
    backgroundColor: "#4caf50",
    borderRadius: "8px",
  },
  forgotPassword: {
    textAlign: "center",
    color: "white",
    fontStyle: "italic",
    textDecoration: "underline",
    marginBottom: theme.spacing(3),
    cursor: "pointer",
  },
  loginButton: {
    backgroundColor: "#4caf50",
    color: "white",
    borderRadius: "8px",
    width: "100%",
    padding: theme.spacing(1.5),
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#45a049",
    },
  },
  loading: {
    display: "flex",
    justifyContent: "center",
  },
  errorMessage: {
    color: "red",
    marginBottom: theme.spacing(2),
    textAlign: "center",
  },
  resetButton: {
    backgroundColor: "#2196f3",
    color: "white",
    borderRadius: "8px",
    width: "100%",
    padding: theme.spacing(1.5),
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#1e88e5",
    },
  },
}));

const Login = () => {
  const classes = useStyles();
  const { login } = useAuth();

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isResettingPassword, setIsResettingPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    localStorage.clear(); // Aquí invocas el método
  });

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const togglePasswordVisibilityConfirm = () => {
    setShowPasswordConfirm((prev) => !prev);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleResetPassword = () => {
    if (!email || !validateEmail(email)) {
      setError("Por favor, ingrese un correo válido.");
      return;
    }

    if (!newPassword || newPassword !== confirmPassword) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    setError("");
    setIsResettingPassword(false);
    alert("Contraseña cambiada con éxito. Ahora puede iniciar sesión.");
  };

  // const handleLogin = async () => {
  //   if (!email || !password) {
  //     setError("Por favor, complete todos los campos.");
  //     return;
  //   }

  //   if (!validateEmail(email)) {
  //     setError("El correo electrónico no es válido.");
  //     return;
  //   }

  //   try {
  //     // Llamada al backend para autenticación
  //     const response = await api.loginUsuario({ email, password });

  //     if (response.success) {
  //       // Guardar token o datos en localStorage
  //       localStorage.setItem("token", response.token);
  //       localStorage.setItem("userData", JSON.stringify(response.user));

  //       // Redirigir al dashboard o página principal
  //       window.open("/admin/inicio/index", "_self");
  //     } else {
  //       // Mostrar mensaje de error del backend
  //       setError(response.message || "Error al iniciar sesión.");
  //     }
  //   } catch (error) {
  //     console.error("Error al iniciar sesión:", error);
  //     setError("Ocurrió un error. Intenta nuevamente.");
  //   }
  // };

  const handleLogin = async () => {
    if (!email || !password) {
      setError("Por favor, complete todos los campos.");
      return;
    }

    if (!validateEmail(email)) {
      setError("El correo electrónico no es válido.");
      return;
    }

    try {
      setLoading(true);
      const response = await api.loginUsuario({ email, password });
      if (response.success) {
        login(response.user, response.token); // setea usuario y token
        window.open("/admin/inicio/index", "_self");
      } else {
        setError(response.message || "Error al iniciar sesión.");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error al iniciar sesión:", error);
      setError(`${error.message}`);
      setLoading(false);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.loginBox}>
        {isResettingPassword ? (
          <>
            <Typography variant="h5" className={classes.title}>
              Cambiar Contraseña
            </Typography>
            {error && (
              <Typography className={classes.errorMessage}>{error}</Typography>
            )}
            <Typography className={classes.inputLabel}>
              Correo de Usuario
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              className={classes.textField}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Typography className={classes.inputLabel}>
              Nueva Contraseña
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              className={classes.textFieldPass}
              type={showPassword ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={togglePasswordVisibility}>
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Typography className={classes.inputLabel}>
              Confirmar Contraseña
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              className={classes.textFieldPass}
              type={showPasswordConfirm ? "text" : "password"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={togglePasswordVisibilityConfirm}>
                      {showPasswordConfirm ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              className={classes.resetButton}
              onClick={handleResetPassword}
            >
              Guardar
            </Button>
          </>
        ) : (
          <>
            <Typography variant="h5" className={classes.title}>
              Iniciar Sesión
            </Typography>
            {error && (
              <Typography className={classes.errorMessage}>{error}</Typography>
            )}
            <Typography className={classes.inputLabel}>
              Correo de Usuario
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              className={classes.textField}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Typography className={classes.inputLabel}>Contraseña</Typography>
            <TextField
              variant="outlined"
              fullWidth
              className={classes.textFieldPass}
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleLogin();
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={togglePasswordVisibility}>
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Typography
              className={classes.forgotPassword}
              onClick={() => setIsResettingPassword(true)}
            >
              ¿Olvidaste tu contraseña?
            </Typography>
            {loading ? (
              <div className={classes.loading}>
                <CircularProgress size={24} />
              </div>
            ) : (
              <Button className={classes.loginButton} onClick={handleLogin}>
                Iniciar Sesión
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Login;
